
import React from "react";

import {
  Box,
  VStack,
  Text,
  Divider,
  HStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Button,
  useColorModeValue,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  Tooltip,
  Avatar,

} from "@chakra-ui/react";

import { Link, useLocation } from "react-router-dom";

import {
  FaChartLine,
  FaClipboardList,
  FaBookOpen,
  FaFileAlt,
  FaHistory,
  FaLifeRing,
  FaShoppingCart,
  FaUserCog,
  FaHome,
  
} from "react-icons/fa";

import  { useState } from 'react';

import { useStudentContext } from "../Student/B2CStudentContext";
import StudentSideBarLayout from "../Student/Layouts/StudentSideBarLayout";
import { useStudentSidebar } from "../Student/Layouts/StudentSidebarContext";

const B2CStudentSideBar = () => {

  const { studentContext } = useStudentContext();
    const { isCollapsed } = useStudentSidebar();

  const location = useLocation();

  const sidebarBg = useColorModeValue(
    "white",
    "gray.900"
  );

  const hoverBg = useColorModeValue(
    "gray.100",
    "gray.800"
  );

  const sectionText = useColorModeValue(
    "gray.700",
    "gray.200"
  );

  const mutedText = useColorModeValue(
    "gray.500",
    "gray.400"
  );

const renderSidebarLink = (
  to: string,
  label: string,
  icon: React.ReactElement,
  pl = 4,
  activeOverride?: boolean   // [MY PROGRESS HIGHLIGHT] optional explicit active state
) => {
  const isActive = activeOverride ?? location.pathname === to;

  const button = (
    <Button
      as={Link}
      to={to}
      justifyContent={isCollapsed ? "center" : "flex-start"}
      variant="ghost"
      size="sm"
      pl={isCollapsed ? 0 : pl}
      py={5}
      borderRadius="lg"
      bg={isActive ? hoverBg : "transparent"}
      _hover={{ bg: hoverBg }}
      fontWeight={isActive ? "semibold" : "medium"}
      w={isCollapsed ? "100%" : undefined}
    >
      <HStack spacing={isCollapsed ? 0 : 3}>
        {icon}
        {!isCollapsed && <Text fontSize="sm">{label}</Text>}
      </HStack>
    </Button>
  );

  return isCollapsed ? (
    <Tooltip label={label} placement="right" hasArrow>
      {button}
    </Tooltip>
  ) : (
    button
  );
};

const renderCollapsedEntitlement = (entitlement: any) => {
  const practiceSet = entitlement.practice_set;
  if (!practiceSet) return null;

 // const basePath = `/practice/app/practice-set/${practiceSet.practice_set_id}`;
 const basePath = `/practice/app/entitlement/${entitlement.entitlement_id}/practice-set/${practiceSet.practice_set_id}`;

  const sortedSections = [...(practiceSet.sections ?? [])].sort(
    (a, b) => a.sequence_number - b.sequence_number
  );

  return (
    <Popover
      key={entitlement.entitlement_id}
      placement="right-start"
      isLazy
    >
      <PopoverTrigger>
        <Button variant="ghost" size="sm" w="100%" justifyContent="center" py={5} borderRadius="lg" _hover={{ bg: hoverBg }}>
          <Avatar
            size="xs"
            name={practiceSet.title}
            getInitials={(name) => name.slice(0, 2).toUpperCase()}
          />
        </Button>
      </PopoverTrigger>

      <Portal>
        <PopoverContent w="240px" boxShadow="xl" zIndex={1500}>
          <PopoverArrow />
          <PopoverBody px={2} py={3}>
            <VStack align="stretch" spacing={1}>
              <Text fontSize="sm" fontWeight="bold" color={sectionText} px={2} noOfLines={2}>
                {practiceSet.title}
              </Text>
              <Text fontSize="11px" color={mutedText} px={2} mb={1}>
                {practiceSet.edition_label}
              </Text>

              <Divider mb={1} />

              <Button as={Link} to={`${basePath}/dashboard`} variant="ghost" size="sm" justifyContent="flex-start" borderRadius="lg" _hover={{ bg: hoverBg }}>
                <HStack spacing={3}><FaChartLine /><Text fontSize="sm">Dashboard</Text></HStack>
              </Button>

              {sortedSections.length > 0 && (
                <>
                  <Text fontSize="11px" fontWeight="semibold" color={mutedText} px={2} pt={2}>
                    PRACTICE
                  </Text>
                  {sortedSections.map((section) => (
                    <Button
                      key={section.practice_set_section_id}
                      as={Link}
                      to={`${basePath}/practice/${section.practice_set_section_id}`}
                      variant="ghost"
                      size="sm"
                      justifyContent="flex-start"
                      pl={6}
                      borderRadius="lg"
                      _hover={{ bg: hoverBg }}
                    >
                      <HStack spacing={3}><FaClipboardList /><Text fontSize="sm" noOfLines={1}>{section.title}</Text></HStack>
                    </Button>
                  ))}
                </>
              )}

              <Button as={Link} to={`${basePath}/mock-exams`} variant="ghost" size="sm" justifyContent="flex-start" borderRadius="lg" _hover={{ bg: hoverBg }} mt={1}>
                <HStack spacing={3}><FaFileAlt /><Text fontSize="sm">Mock Exams</Text></HStack>
              </Button>

              <Button as={Link} to={`${basePath}/attempts`} variant="ghost" size="sm" justifyContent="flex-start" borderRadius="lg" _hover={{ bg: hoverBg }}>
                <HStack spacing={3}><FaChartLine /><Text fontSize="sm">My Progress</Text></HStack>
              </Button>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

// Put this next to your sidebar component (or in the same file)
const CollapsedEntitlementPopover = ({
  entitlement,
  hoverBg,
  sectionText,
  mutedText,
}: {
  entitlement: any;
  hoverBg: string;
  sectionText: string;
  mutedText: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  const practiceSet = entitlement.practice_set;
  if (!practiceSet) return null;

  const basePath = `/practice/app/entitlement/${entitlement.entitlement_id}/practice-set/${practiceSet.practice_set_id}`;
  const sortedSections = [...(practiceSet.sections ?? [])].sort(
    (a, b) => a.sequence_number - b.sequence_number
  );

  return (
    <Popover
      placement="right-start"
      isLazy
      isOpen={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={close}
    >
      <PopoverTrigger>
        <Button
          variant="ghost"
          size="sm"
          w="100%"
          justifyContent="center"
          py={5}
          borderRadius="lg"
          _hover={{ bg: hoverBg }}
        >
          <Avatar
            size="xs"
            name={practiceSet.title}
            getInitials={(name) => name.slice(0, 2).toUpperCase()}
          />
        </Button>
      </PopoverTrigger>

      <Portal>
        <PopoverContent w="240px" boxShadow="xl" zIndex={1500}>
          <PopoverArrow />
          <PopoverBody px={2} py={3}>
            <VStack align="stretch" spacing={1}>
              <Text fontSize="sm" fontWeight="bold" color={sectionText} px={2} noOfLines={2}>
                {practiceSet.title}
              </Text>
              <Text fontSize="11px" color={mutedText} px={2} mb={1}>
                {practiceSet.edition_label}
              </Text>
              <Divider mb={1} />

              <Button as={Link} to={`${basePath}/dashboard`} onClick={close} variant="ghost" size="sm" justifyContent="flex-start" borderRadius="lg" _hover={{ bg: hoverBg }}>
                <HStack spacing={3}><FaChartLine /><Text fontSize="sm">Dashboard</Text></HStack>
              </Button>

              {sortedSections.length > 0 && (
                <>
                  <Text fontSize="11px" fontWeight="semibold" color={mutedText} px={2} pt={2}>
                    PRACTICE
                  </Text>
                  {sortedSections.map((section) => (
                    <Button
                      key={section.practice_set_section_id}
                      as={Link}
                      to={`${basePath}/practice/${section.practice_set_section_id}`}
                      onClick={close}
                      variant="ghost"
                      size="sm"
                      justifyContent="flex-start"
                      pl={6}
                      borderRadius="lg"
                      _hover={{ bg: hoverBg }}
                    >
                      <HStack spacing={3}><FaClipboardList /><Text fontSize="sm" noOfLines={1}>{section.title}</Text></HStack>
                    </Button>
                  ))}
                </>
              )}

              <Button as={Link} to={`${basePath}/mock-exams`} onClick={close} variant="ghost" size="sm" justifyContent="flex-start" borderRadius="lg" _hover={{ bg: hoverBg }} mt={1}>
                <HStack spacing={3}><FaFileAlt /><Text fontSize="sm">Mock Exams</Text></HStack>
              </Button>

              <Button as={Link} to={`${basePath}/attempts`} onClick={close} variant="ghost" size="sm" justifyContent="flex-start" borderRadius="lg" _hover={{ bg: hoverBg }}>
                <HStack spacing={3}><FaChartLine /><Text fontSize="sm">My Progress</Text></HStack>
              </Button>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
// ===== [MY PROGRESS HIGHLIGHT] START =====
// My Progress is "active" on the attempts listing, on the question-set and
// exam attempt listings, and (point 2) on the attempt details viewer.
const isMyProgressActive = (basePath: string, entitlementId: number) => {
  const p = location.pathname;

  // Attempts listings: /attempts, /practice/x/question-set/y/attempts, /exam/z/attempts
  if (p.startsWith(`${basePath}/`) && p.endsWith("/attempts")) return true;

  // Attempt details viewer has no entitlement in its URL, so it can only
  // light up ONE entitlement: the one passed via navigation state, else the
  // last active one, else the first.
  if (p.startsWith("/practice/app/practice-attempt/") && p.endsWith("/view")) {
    const viewerEntitlementId = Number(
      (location.state as any)?.entitlement_id ??
      studentContext?.last_active_entitlement_id ??
      studentContext?.entitlements?.[0]?.entitlement_id
    );
    return viewerEntitlementId === Number(entitlementId);
  }

  return false;
};
// ===== [MY PROGRESS HIGHLIGHT] END =====

const [expandedPractice, setExpandedPractice] =
  useState<Record<number, boolean>>({});



  return (

    <StudentSideBarLayout>

      <Box
        bg={sidebarBg}
        h="100%"
        overflowY="auto"
        px={3}
        py={4}
      >

        <VStack
          align="stretch"
          spacing={2}
        >

          {/* ========================================= */}
          {/* GLOBAL DASHBOARD */}
          {/* ========================================= */}

{/*           {renderSidebarLink(
            "/practice/app/dashboard",
            "Global Dashboard",
            <FaHome />
          )} */}

          <Divider my={2} />

          {/* ========================================= */}
          {/* ENTITLEMENTS */}
          {/* ========================================= */}

          {isCollapsed ? (
            <VStack align="stretch" spacing={2}>
              {studentContext?.entitlements?.map((entitlement) => (
                <CollapsedEntitlementPopover
                  key={entitlement.entitlement_id}
                  entitlement={entitlement}
                  hoverBg={hoverBg}
                  sectionText={sectionText}
                  mutedText={mutedText}
                />
              ))}
            </VStack>
          ) : (
            // … existing Accordion stays exactly the same
            <Accordion
              allowMultiple
              defaultIndex={[0]}
            >

              {studentContext?.entitlements?.map(
                (entitlement) => {

                  const practiceSet =
                    entitlement.practice_set;

                  if (!practiceSet) return null;

              //    const basePath = `/practice/app/practice-set/${practiceSet.practice_set_id}`;

                    // FIX: was entitlement.entitlement_id — must match router's :practice_set_id
                const basePath = `/practice/app/entitlement/${entitlement.entitlement_id}/practice-set/${practiceSet.practice_set_id}`;


                  return (

                    <AccordionItem
                      key={entitlement.entitlement_id}
                      border="none"
                      mb={2}
                    >

                      <AccordionButton
                        borderRadius="lg"
                        _hover={{
                          bg: hoverBg
                        }}
                        px={3}
                      >

                        <Box
                          flex="1"
                          textAlign="left"
                        >

                          <Text
                            fontSize="sm"
                            fontWeight="bold"
                            color={sectionText}
                          >
                            {practiceSet.title}
                          </Text>

                          <Text
                            fontSize="11px"
                            color={mutedText}
                          >
                            {practiceSet.edition_label}
                          </Text>

                        </Box>

                        <AccordionIcon />

                      </AccordionButton>

                      <AccordionPanel
                        pt={2}
                        pb={1}
                        px={1}
                      >

                        <VStack
                          align="stretch"
                          spacing={1}
                        >

                          {/* DASHBOARD */}

                          {renderSidebarLink(
                            `${basePath}/dashboard`,
                            "Dashboard",
                            <FaChartLine />,
                            8
                          )}


                          {/* PRACTICE */}

                          <Box>

                          {/* PRACTICE HEADER */}

                          <Button
                          variant="ghost"
                          size="sm"
                          justifyContent="space-between"
                          w="100%"
                          pl={8}
                          py={5}
                          borderRadius="lg"
                          fontWeight="medium"
                          _hover={{
                                bg: hoverBg
                          }}
                          onClick={() =>
                                setExpandedPractice((prev) => ({
                                ...prev,
                                [entitlement.entitlement_id]:
                                !prev[entitlement.entitlement_id]
                                }))
                          }
                          >

                          <HStack spacing={3}>
                                <FaBookOpen />

                                <Text fontSize="sm">
                                Practice
                                </Text>
                          </HStack>

                          <Box
                                transition="transform 0.2s ease"
                                transform={
                                expandedPractice[
                                entitlement.entitlement_id
                                ]
                                ? "rotate(180deg)"
                                : "rotate(0deg)"
                                }
                          >
                                <AccordionIcon />
                          </Box>

                          </Button>

                          {/* PRACTICE CHILDREN */}

                          {expandedPractice[
                          entitlement.entitlement_id
                          ] && (

                          <VStack
                                align="stretch"
                                spacing={1}
                                mt={1}
                          >

                                {practiceSet.sections
                                ?.sort(
                                (a, b) =>
                                      a.sequence_number -
                                      b.sequence_number
                                )
                                .map((section) => {

                                const sectionSlug =
                                      section.title
                                      .toLowerCase()
                                      .replaceAll(" ", "-");

                                return renderSidebarLink(
                                      `${basePath}/practice/${section.practice_set_section_id}`,
                                      section.title,
                                      <FaClipboardList />,
                                      10
                                );
                                })}

                          </VStack>

                          )}

                          </Box>

                          {/* MOCK EXAMS */}

                          {renderSidebarLink(
                            `${basePath}/mock-exams`,
                            "Mock Exams",
                            <FaFileAlt />,
                            8
                          )}


                          {/* ANALYTICS & ATTEMPT HISTORY */}

                          {renderSidebarLink(
                            `${basePath}/attempts`,
                            "My Progress",
                            <FaChartLine />,
                            8,
                            isMyProgressActive(basePath, entitlement.entitlement_id) // [MY PROGRESS HIGHLIGHT]
                          )}

                          {/* RESOURCES */}

  {/*                         {renderSidebarLink(
                            `${basePath}/resources`,
                            "Resources",
                            <FaBookOpen />,
                            8
                          )} */}

                        </VStack>

                      </AccordionPanel>

                    </AccordionItem>
                  );
                }
              )}

            </Accordion>
          )}

          <Divider my={2} />

          {/* ========================================= */}
          {/* GLOBAL LINKS */}
          {/* ========================================= */}

          {renderSidebarLink(
            "/practice/app/orders",
            "Orders & Purchases",
            <FaShoppingCart />
          )}

          {renderSidebarLink(
            "/practice/app/profile",
            "Profile & Settings",
            <FaUserCog />
          )}

          {renderSidebarLink(
            "/practice/app/support",
            "Support",
            <FaLifeRing />
          )}

        </VStack>

      </Box>

    </StudentSideBarLayout>
  );
};

export default B2CStudentSideBar;

